import React from "react";
import '../App.css';
import '../blocks/customblocks';
import '../generator/generator';
import styles from "../styles/level1.module.css"
import instrLink from "../images/level0/instrLink.png"
import BlocklyComponent, { Block, Value, Field, Shadow } from '../Blockly';
import L3 from '../toolboxes/L3';
import level3Task0 from '../solutionxml/level3Task0'
import level3Task1 from '../solutionxml/level3Task1'
import level3Task2 from '../solutionxml/level3Task2'
const level3 = () => {
  return (
    <div className={styles.container}>
    <main>
      <h1 className={styles.title}>
        Level 3: Lists 
      </h1>
      <br></br>
      <br></br>
      <div className={styles.center}>
        <h3 className={styles.instructions}> 
        Task 0: Let’s imagine we currently have three crops planted in the garden and we want to make a list of what is in the garden. Create a list called “garden_list” with the following items: tomatoes, blueberries, and carrots. 
After harvesting the tomatoes in the garden, you decide to replace them with cucumbers. Use ‘set’ to change your list and replace the tomato item with cucumbers!

        </h3>
      </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 0 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      toolbox={L3}
      solutionXml={level3Task0}
      >
      </BlocklyComponent>
  </div>
  <br></br>
  <br></br>
  <div className={styles.center}>
        <h3 className={styles.instructions}> Task 1: Let’s practice indexes! Create a list of all the odd numbers up to 10. Use your understanding of indexes to ‘get’ the number 5 and print the value to check. </h3>
      </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 0 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
      <br></br>
  
  <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      toolbox={L3}
      solutionXml={level3Task1}
      >
      </BlocklyComponent>
  </div>
  
  <br></br>
  <div className={styles.center}>
        <h3 className={styles.instructions}> Task 2: The block ‘sort’ allows you to sort numbers in increasing or decreasing order. Create a list of 3 random fractions using the ‘random fraction’ block and use the sort block to sort them in increasing order. Make sure to print out your list to check!

Use the 'Run' button to see the output!</h3>
      </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 0 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
      <div className="App">
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      toolbox={L3}
      solutionXml={level3Task2}
      >
      </BlocklyComponent>
  </div>
  <br></br>
  <br></br>
  </main>
  </div>
  
  );
}
  
export default level3;